

export default function getTimeElapsedSince(startTime) {
    return Math.round(new Date().getTime() - startTime);
}
